// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const darmanitan_standard: PokeData = {
  "id": 555,
  "name": "darmanitan-standard",
  "height": 13,
  "weight": 929,
  "base_experience": 168,
  "types": [
    PokeType.FIRE
  ],
  "api_moves": [
    "fire-punch",
    "headbutt",
    "tackle",
    "thrash",
    "bite",
    "ember",
    "rage",
    "belly-drum",
    "rollout",
    "swagger",
    "uproar",
    "facade",
    "taunt",
    "superpower",
    "overheat",
    "hammer-arm",
    "flare-blitz",
    "fire-fang",
    "incinerate",
    "work-up"
  ],
  "moves": [
    "fire-punch",
    "headbutt",
    "tackle",
    "bite",
    "ember",
    "superpower",
    "flare-blitz",
    "fire-fang",
    "blaze-kick",
    "fire-ball",
    "flamethrower",
    "fire-spin",
    "eruption"
  ],
  "evolution_chain": {
    "id": 282,
    "item": null,
    "species": [
      {
        "name": "darumaka",
        "order": 555,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "darmanitan",
        "order": 556,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": 554,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 35,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          },
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "ice-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 102,
    "speed": 121,
    "ability_power": 178
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
